import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Trash2, Pin } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, NOTE_COLORS } from "@/lib/api";
import { inputCls, btnPrimary, btnSecondary, ColorPicker } from "@/components/shared";

export const NoteDialog = ({ state, onClose, onSaved }) => {
  const [form, setForm] = useState({});
  useEffect(() => {
    if (!state) return;
    const n = state.note;
    setForm(n ? { title: n.title, content: n.content, color: n.color, pinned: n.pinned } : { title: "", content: "", color: "oat", pinned: false });
  }, [state]);
  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const save = async (e) => {
    e.preventDefault();
    if (!form.title?.trim()) return;
    const body = { ...form, title: form.title.trim() };
    if (state.note) await api.patch(`/notes/${state.note.id}`, body);
    else await api.post("/notes", body);
    toast.success("Note saved");
    onSaved();
    onClose();
  };
  const remove = async () => {
    await api.delete(`/notes/${state.note.id}`);
    toast("Note deleted");
    onSaved();
    onClose();
  };

  return (
    <Dialog open={!!state} onOpenChange={(o) => !o && onClose()}>
      <DialogContent aria-describedby={undefined} className="border-t-line rounded-2xl sm:max-w-xl" style={{ backgroundColor: NOTE_COLORS[form.color] || "rgb(var(--t-bg))" }} data-testid="note-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif-display text-3xl font-semibold">{state?.note ? "Edit note" : "New note"}</DialogTitle>
        </DialogHeader>
        <form onSubmit={save} className="space-y-4">
          <input data-testid="note-title-input" className={`${inputCls} font-serif-display text-xl`} value={form.title || ""} onChange={set("title")} placeholder="Title" autoFocus />
          <textarea data-testid="note-content-input" rows={8} className={inputCls} value={form.content || ""} onChange={set("content")} placeholder="Write anything..." />
          <div className="flex items-center justify-between gap-3 flex-wrap">
            <ColorPicker value={form.color} onChange={(c) => setForm((f) => ({ ...f, color: c }))} palette={NOTE_COLORS} testPrefix="note" />
            <button type="button" data-testid="note-pin-toggle" onClick={() => setForm((f) => ({ ...f, pinned: !f.pinned }))}
              className={`${btnSecondary} ${form.pinned ? "text-t-primary border-t-primary/40" : ""}`}>
              <Pin className="h-4 w-4" fill={form.pinned ? "currentColor" : "none"} /> {form.pinned ? "Pinned" : "Pin"}
            </button>
          </div>
          <div className="flex gap-3">
            {state?.note && (
              <button type="button" data-testid="note-delete-button" onClick={remove} className={`${btnSecondary} text-t-danger`}><Trash2 className="h-4 w-4" /> Delete</button>
            )}
            <button type="submit" data-testid="note-save-button" className={`${btnPrimary} flex-1`}>Save note</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
